/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HTTPLink } from './HTTPLink';
import {
    HTTPLinkFromJSON,
    HTTPLinkFromJSONTyped,
    HTTPLinkToJSON,
    HTTPLinkToJSONTyped,
} from './HTTPLink';

/**
 * 
 * @export
 * @interface GlossaryTermDTO
 */
export interface GlossaryTermDTO {
    /**
     * 
     * @type {string}
     * @memberof GlossaryTermDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GlossaryTermDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GlossaryTermDTO
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof GlossaryTermDTO
     */
    imageId?: string;
    /**
     * 
     * @type {Array<HTTPLink>}
     * @memberof GlossaryTermDTO
     */
    links: Array<HTTPLink>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlossaryTermDTO
     */
    additionalImageIds?: Array<string>;
}

/**
 * Check if a given object implements the GlossaryTermDTO interface.
 */
export function instanceOfGlossaryTermDTO(value: object): value is GlossaryTermDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    return true;
}

export function GlossaryTermDTOFromJSON(json: any): GlossaryTermDTO {
    return GlossaryTermDTOFromJSONTyped(json, false);
}

export function GlossaryTermDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlossaryTermDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'links': ((json['links'] as Array<any>).map(HTTPLinkFromJSON)),
        'additionalImageIds': json['additionalImageIds'] == null ? undefined : json['additionalImageIds'],
    };
}

export function GlossaryTermDTOToJSON(json: any): GlossaryTermDTO {
    return GlossaryTermDTOToJSONTyped(json, false);
}

export function GlossaryTermDTOToJSONTyped(value?: GlossaryTermDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'imageId': value['imageId'],
        'links': ((value['links'] as Array<any>).map(HTTPLinkToJSON)),
        'additionalImageIds': value['additionalImageIds'],
    };
}

